import { Grid } from '@mui/material';
import { memo } from 'react';

interface ParentElementProps {
  children: React.ReactNode;
  disabledComponent?: boolean;
}

const ParentElementComponent = ({
  children,
  disabledComponent,
}: ParentElementProps): React.ReactElement => {
  if (disabledComponent) {
    return <>{children}</>;
  }
  return (
    <Grid item xs={12} container spacing={0} rowSpacing={{ xs: 1, md: 0 }} columnSpacing={1}>
      {children}
    </Grid>
  );
};

ParentElementComponent.displayName = 'Parent Element';

const ParentElement = memo(ParentElementComponent) as typeof ParentElementComponent;

export default ParentElement;
